<template>
  <div style="background-color:white">
    <el-row style="padding-top:10px">
      <el-col :span="24">
        <el-button size="small" class="btn" type="primary" v-if="show.sc" @click="handleCreate">资料上传</el-button>
        <el-form :inline="true" ref="deviceInfo" :model="deviceInfo" class="demo-form-inline"
          style="float:right!important">
          <!-- <el-form-item :label="lable.companyName">
            <el-cascader v-model="deviceInfo.companyCode" style="width:140px" :options="options" :props="props1" clearable
              :show-all-levels="true" filterable placeholder="请选择"></el-cascader>
          </el-form-item> -->
           <el-form-item label="上传单位">
            <!-- <el-cascader v-model="searchModel.company" style="width:100%;" clearable :options="companySelect"
                            :props="companyProps" placeholder="请选择使用部门" :show-all-levels="false" filterable></el-cascader> -->
            <el-cascader
              v-model="deviceInfo.companyCode"
              style="width: 100%"
              :options="companySelect"
              :props="companyProps"
              clearable
              :show-all-levels="false"
              filterable
              placeholder="请选择上传单位"
            ></el-cascader>
          </el-form-item>
          <el-form-item :label="lable.createTime">
            <el-date-picker v-model="deviceInfo.date" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="模糊搜索">
            <el-input v-model="deviceInfo.content" auto-complete="off" placeholder="请输入搜索内容"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="getDeviceinfoClick">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }" ref="multipleTable" :data="deviceData" tooltip-effect="dark"
          style="width: 100%;text-align:center" stripe>
          <el-table-column :label="lable.index" type="index" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="typeName" :label="lable.typeName" width="120PX">
          </el-table-column>

          <el-table-column prop="name" :label="lable.name" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="fileDesc" :label="lable.fileDesc" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="companyName" :label="lable.companyName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column sortable prop="createTime" :label="lable.createTime" :formatter="formateTime"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="id" :label="lable.cz" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button @click="updateClick(scope.row)" v-if="show.xg" type="text" size="small">修改</el-button>
              <el-button @click="deleteFile(scope.row)" v-if="show.zf" type="text" size="small">删除</el-button>
              <el-button @click="yulan(scope.row)" v-if="show.yl" type="text" size="small">预览</el-button>
              <el-button type="text" size="small" v-if="show.xz" @click="downloading(scope.row)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top:5px;height: 35px;">
        <el-pagination v-if="deviceData.length > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
          :total="total" style="float:right">
        </el-pagination>
      </el-col>
    </el-row>
    <el-dialog width="30%" title="添加资料" :visible.sync="innerVisible" append-to-body :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item :label="lable.typeName">
          <el-select v-model="form.typeId" style="width:100%" placeholder="请选择" clearable>
            <el-option v-for="item in typeOptions" :key="item.id" :label="item.typeName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="lable.name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item :label="lable.fileDesc">
          <el-input v-model="form.fileDesc"></el-input>
        </el-form-item>
        <el-form-item label="选择">
          <el-upload class="upload" ref="upload" action="string" :file-list="fileList" :auto-upload="false"
            :http-request="uploadFile" :on-change="handleChange" :on-preview="handlePreview" :on-remove="handleRemove"
            multiple="multiple">
            <el-button slot="trigger" size="small" type="primary" @click="delFile">选取文件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" v-preventReClick>上传</el-button>
          <el-button @click="innerVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!----------------------------------------------------------------------------修改弹窗----------------------------------------------------------------------------->
    <el-dialog width="30%" title="修改资料" :visible.sync="innerVisible1" append-to-body :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item :label="lable.typeName">

          <el-select v-model="form.typeId" style="width:100%" placeholder="请选择" clearable>
            <el-option v-for="item in typeOptions" :key="item.id" :label="item.typeName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="lable.name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item :label="lable.fileDesc">
          <el-input v-model="form.fileDesc"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="upadtaFile" v-preventReClick>修改</el-button>
          <el-button @click="innerVisible1 = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :title="previewTitle" :visible.sync="docxdialog" style="margin-top:-50px" width="63%">
      <FilePreview ref="filePreview" />
    </el-dialog>
  </div>
</template>
<script>
import { findAllData, findAllType, treeCompany, addFile, updateData, deleteData, findByModule,findByUserIdCompanyTree } from "../../api/api";
import FilePreview from '../../components/preview/FilePreview.vue'

export default {
  name: "Rules",
  components: {
    "FilePreview": FilePreview,
  },
  data() {
    return {
      deviceInfo: {
        companyCode: "",
        date: "",
        content: ""
      },
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      innerVisible: false,
      innerVisible1: false,
      multipleTable: [],
      deviceData: [],
      optionTasks: [],
      form: {},
      fileData: [],
      fileList: [],
      options: [],
      // props1: {
      //   label: 'companyName',
      //   value: 'companyCode',
      //   children: 'zcompany',
      //   expandTrigger: 'click',
      //   emitPath: false
      // },
       companyProps: {
        checkStrictly: true,
        label: "companyName",
        value: "companyCode",
        children: "zcompany",
        emitPath: false
      },
      lable: {},
      typeOptions: [],
      docxdialog: false,
      previewTitle: '',
      show: {
        xz: false,
        yl: false,
        xg: false,
        sc: false,
        zf: false
      },
      companySelect: [],
    };
  },
  mounted() {
    this.findLable();
    this.selectCompany();
    this.getDeviceinfo();
    this.selectAllType();
    var userinfo = JSON.parse(localStorage.getItem("user"))
    var arr = userinfo.role.menuId.split(",");
    arr.forEach((i) => {
      if (i == "123") {
        this.show.xz = true;
      }
      if (i == "122") {
        this.show.yl = true;
      }
      if (i == "121") {
        this.show.xg = true;
      }
      if (i == "120") {
        this.show.sc = true;
      }
      if (i == "144") {
        this.show.zf = true;
      }
    })
  },
  methods: {
    findLable() {
      findByModule('培训资料').then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },
    yulan(row) {
      if (row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpg' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'png' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpeg') {
        this.previewTitle = "图片预览"
      } else {
        this.previewTitle = "文件预览"
      }
      this.docxdialog = true
      this.$nextTick(() => {
        this.$refs.filePreview.showView(row.path)
      })
      // this.downloadUtil.preview(row.path)
    },
    // 格式化时间显示到日期
    formateTime(row) {
      let nowData = new Date(row.createTime)
      let year = nowData.getFullYear();
      let month = (nowData.getMonth() + 1).toString().padStart(2, '0');
      let date = nowData.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${date}`;
    },
    downloading(scop) {
      this.downloadUtil.downloadFile(scop.path, scop.name);
    },
    //删除资料信息
    deleteFile(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteData(row.id).then(datas => {
          // debugger
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error"
            });
          } else if (status == 200) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.innerVisible1 = false
            this.getDeviceinfo();
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
        });
      })
    },
    //更新资料信息
    upadtaFile() {
      updateData(this.form).then(datas => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.$message({
            message: "更新成功",
            type: "success"
          });
          this.innerVisible1 = false
          this.getDeviceinfo();
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    //修改资料
    updateClick(row) {
      this.innerVisible1 = true;
      this.form = row;
    },
    //查找类型
    selectAllType() {
      findAllType().then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.typeOptions = data;
        }
      });
    },
    //查找单位
    selectCompany() {
      // treeCompany().then(datas => {
      //   let { status, message, data } = datas;
      //   if (status == 200) {
      //     this.options = this.getTreeData1(data);
      //   }
      // });
      var userinfo = JSON.parse(localStorage.getItem("user"));
      var companyCode = "";
      if (
        userinfo.userRole == 1 ||
        (userinfo.fjqx != null &&
          (userinfo.fjqx.indexOf("3") != -1 ||
            userinfo.fjqx.indexOf("4") != -1))
      ) {
        companyCode = "-1";
      } else {
        companyCode = userinfo.companyCode;
      }
      findByUserIdCompanyTree(companyCode).then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.companySelect = this.getCompanyTreeData(data);
        }
      });
    },
     getCompanyTreeData(companyData) {
      for (let i = 0; i < companyData.length; i++) {
        if (companyData[i].zcompany.length > 0) {
          // children不为空时继续调用该方法
          this.getCompanyTreeData(companyData[i].zcompany);
        } else {
          // 最后一级没有数据将children变成undefined
          companyData[i].zcompany = undefined;
        }
      }
      return companyData;
    },
    getTreeData1(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].zcompany.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].zcompany = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData1(data[i].zcompany);
        }
      }
      return data;
    },
    getDeviceinfoClick(){
      this.pageIndex=1
      this.getDeviceinfo()
    },
    handleCreate() {
      this.form = {},
        this.fileList = [];
      this.innerVisible = true;
    },

    //点击上传文件触发的额外事件,清空fileList
    delFile() {
      this.fileList = [];
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    //自定义上传文件
    uploadFile(file) {
      this.formData.append("file", file.file);
    },
    //删除文件
    handleRemove(file, fileList) {
    },
    // 点击文件
    handlePreview(file) {
    },
    //创建时文件上传
    onSubmit() {
      if (this.fileList[0] == null) {
        this.$message.error("请选择上传的文件"); // .....失败信息
      } else {
        var formData = new FormData();
        formData.append("file", this.fileList[0].raw); //拿到存在fileList的文件存放到formData中
        //下面数据是我自己设置的数据,可自行添加数据到formData(使用键值对方式存储)
        formData.append("name", this.form.name == null ? "" : this.form.name);
        formData.append("fileDesc", this.form.fileDesc == null ? "" : this.form.fileDesc);
        var userinfo = JSON.parse(localStorage.getItem("user"))
        formData.append("userId", userinfo.userId)
        formData.append("typeId", this.form.typeId)
        addFile(formData).then(datas => {
          // debugger
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error"
            });
          } else if (status == 200) {
            this.getDeviceinfo();
            this.$message({
              message: "上传成功",
              type: "success"
            });
            this.innerVisible = false;
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }

        });
      }
    },
    //查找资料信息
    getDeviceinfo() {
      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        content: this.deviceInfo.content,
        companyCode: this.deviceInfo.companyCode
      };
      findAllData(map).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          if (data == null) { this.data = [] } else { this.data = data; }
          this.deviceData = this.data.slice(
            (this.pageIndex - 1) * this.pagesize,
            this.pageIndex * this.pagesize
          );
          this.total = data.length;
          // debugger
        }
      });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.deviceData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.deviceData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    }
  }
};
</script>
<style >
.el-checkbox__inner {
    border: 1px solid #606266!important;
}
</style>
<style scoped>
.btn {
  float: left;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/trainingMaterials/Rules.vue